import Autocomplete from '@mui/material/Autocomplete';
import Typography from '@mui/material/Typography';
import React from 'react';

const AutocompleteKit = (props) => {
	const { options, ...rest } = props;

	return (
		<Autocomplete
			options={options}
			loading={options.length === 0}
			getOptionLabel={(option) => <Typography color="#2A2A62">{option.title}</Typography>}
			filterOptions={(option, value) => option.title === value.title}
			fullWidth
			{...rest}
		/>
	);
};

export default AutocompleteKit;

AutocompleteKit.defaultProps = {
	options: [],
};

AutocompleteKit.displayName = 'AutocompleteKit input';
